import format from 'format-number'
import Vue from 'vue'

const formatNumber = (value = 0) => {
  return format({ integerSeparator: '.', decimal: ',' })(Number(value))
}

Vue.filter('number', formatNumber)

export default Vue

export {
  formatNumber
}